import { Card, Box, Button, Text } from '@nimbus-ds/components';
import { InitialScreen } from '@nimbus-ds/patterns';
import { DomainOrderResponseDto } from '@tiendanube/common';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';
import { useSuccessOrderCardLogic } from './useSuccessOrderCardLogic';

interface SuccessOrderCardProps {
  order: DomainOrderResponseDto;
}

export function SuccessOrderCard({ order }: Readonly<SuccessOrderCardProps>) {
  const t = useTranslationConfigurations('domains.orderDetails.successOrder');

  const { heroData, isConfiguring, cooldownSeconds } = useSuccessOrderCardLogic(
    {
      order,
    },
  );

  return (
    <Card>
      <Box padding="8">
        <InitialScreen paddingTop="none">
          <InitialScreen.Hero
            title={heroData.title}
            description={heroData.description}
            image={
              <img src={heroData.image} width="100%" alt={heroData.imageAlt} />
            }
            actions={
              isConfiguring ? (
                <Button
                  onClick={heroData.buttonAction}
                  appearance="primary"
                  disabled={heroData.buttonDisabled}
                >
                  {heroData.buttonText}
                </Button>
              ) : (
                <Box
                  display="flex"
                  flexDirection="row"
                  gap="3"
                  alignItems="center"
                  justifyContent="center"
                  flexWrap="nowrap"
                >
                  <Box flexShrink="0">
                    <Button
                      onClick={heroData.buttonAction}
                      appearance="primary"
                      disabled={heroData.buttonDisabled}
                    >
                      {heroData.buttonText}
                    </Button>
                  </Box>
                  {heroData.showCooldown && (
                    <Box flex="1" maxWidth="32rem">
                      <Text fontSize="caption" color="neutral-textLow">
                        {t('cooldownMessage', { seconds: cooldownSeconds })}
                      </Text>
                    </Box>
                  )}
                </Box>
              )
            }
          />
        </InitialScreen>
      </Box>
    </Card>
  );
}
